import React from 'react'
import './Intro.css'
import Github from '../../img/github.png'
import LinkedIn from '../../img/linkedin.png'
import Portrait from '../../img/boy.png'
import Resume from '../Services/resume.pdf'
import { Link } from 'react-scroll'

const Intro = () => (
  <section className='intro site-shell' id='Intro'>
    <div className='i-left'>
      <span className='availability'><i /> Open to remote opportunities</span>
      <p className='section-eyebrow'>Full-Stack Software Engineer</p>
      <h1>Software built for real operations.</h1>
      <h2>Secure. Scalable. Reliable.</h2>
      <p className='hero-copy'>I design, develop, and deploy production-ready web applications for businesses, public institutions, logistics operations, and digital platforms.</p>
      <div className='i-actions'>
        <a className='button' href={Resume} download='Exauce_Boby_Zakuda_CV.pdf'>Download CV</a>
        <Link to='Contact' smooth><button className='button button-secondary'>Contact Me</button></Link>
      </div>
      <div className='i-icons'>
        <a href='https://github.com/exauceboby' target='_blank' rel='noreferrer'><img src={Github} alt='GitHub' /></a>
        <a href='https://www.linkedin.com/in/exauce-boby-2006ba2a4' target='_blank' rel='noreferrer'><img src={LinkedIn} alt='LinkedIn' /></a>
        <a className='email-link' href='mailto:exauceboby15@gmail.com'>exauceboby15@gmail.com</a>
      </div>
      <div className='hero-tech'><span>React</span><span>Next.js</span><span>Node.js</span><span>TypeScript</span><span>PostgreSQL</span></div>
    </div>
    <div className='i-right'>
      <div className='portrait-frame'><div className='portrait-orb' /><img src={Portrait} alt='Exaucé Boby Zakuda' /></div>
      <div className='hero-profile-card'><strong>Exaucé Boby Zakuda</strong><span>Full-Stack Software Engineer</span><small>Kinshasa, DR Congo</small></div>
    </div>
  </section>
)
export default Intro
